import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postV2ProviderTranscriptionsProxyUpload: build.mutation<
      PostV2ProviderTranscriptionsProxyUploadApiResponse,
      PostV2ProviderTranscriptionsProxyUploadApiArg
    >({
      query: () => ({
        url: `/v2/provider/transcriptions/proxy-upload`,
        method: "POST",
      }),
    }),
    postV2ProviderTranscriptionsRealtimeSession: build.mutation<
      PostV2ProviderTranscriptionsRealtimeSessionApiResponse,
      PostV2ProviderTranscriptionsRealtimeSessionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/transcriptions/realtime/session`,
        method: "POST",
        body: queryArg.createRealtimeSessionRequest,
      }),
    }),
    postV2ProviderTranscriptionsTestUploadUrl: build.mutation<
      PostV2ProviderTranscriptionsTestUploadUrlApiResponse,
      PostV2ProviderTranscriptionsTestUploadUrlApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/transcriptions/test-upload-url`,
        method: "POST",
        body: queryArg.createTestUploadUrlRequest,
      }),
    }),
    postV2ProviderTranscriptionsUploadUrl: build.mutation<
      PostV2ProviderTranscriptionsUploadUrlApiResponse,
      PostV2ProviderTranscriptionsUploadUrlApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/transcriptions/upload-url`,
        method: "POST",
        body: queryArg.createUploadUrlRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type PostV2ProviderTranscriptionsProxyUploadApiResponse = unknown;
export type PostV2ProviderTranscriptionsProxyUploadApiArg = void;
export type PostV2ProviderTranscriptionsRealtimeSessionApiResponse =
  /** status 200 OK */ RealtimeSessionResponse;
export type PostV2ProviderTranscriptionsRealtimeSessionApiArg = {
  createRealtimeSessionRequest: CreateRealtimeSessionRequest;
};
export type PostV2ProviderTranscriptionsTestUploadUrlApiResponse =
  /** status 200 OK */ UploadUrlResponse;
export type PostV2ProviderTranscriptionsTestUploadUrlApiArg = {
  createTestUploadUrlRequest: CreateTestUploadUrlRequest;
};
export type PostV2ProviderTranscriptionsUploadUrlApiResponse =
  /** status 200 OK */ UploadUrlResponse;
export type PostV2ProviderTranscriptionsUploadUrlApiArg = {
  createUploadUrlRequest: CreateUploadUrlRequest;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type RealtimeSessionResponse = {
  /** When the token expires (in seconds) */
  expires_in_seconds: number;
  /** Required audio sample rate in Hz for streaming */
  sample_rate?: number;
  /** Temporary authentication token for streaming */
  token: string;
};
export type CreateRealtimeSessionRequest = {
  /** Token expiration time in seconds (1-600) */
  expires_in_seconds?: number;
};
export type UploadUrlResponse = {
  /** When the upload URL expires */
  expires_at?: string | null;
  /** S3 object key where the file will be stored */
  s3_object_id: string;
  /** Presigned S3 upload URL */
  upload_url: string;
};
export type CreateTestUploadUrlRequest = {
  /** MIME type of the test content */
  content_type?: string;
};
export type CreateUploadUrlRequest = {
  /** MIME type of the content to upload */
  content_type: string;
  /** Unique identifier for the object to upload */
  object_id: string;
};
